export const JSON_HEADER = { 'Content-Type': 'application/json' };
export const FORMDATA_HEADER = { 'Content-Type': 'multipart/form-data' };
